import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {MemberShipTable} from "../../../UI/Membership/MemberShipTable";

const MemberShip = () => {
  return (
    <div>
      <PanelHead title="Memberships" />
      <PanelBody content={<MemberShipTable />} />
    </div>
  );
};

export default React.memo(MemberShip);
